import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './TestimonyPage.css';
import ArrowNavigation from "./ArrowNavigation";
import ContentDisplay from "./ContentDisplay";
import PageDots from "./PageDots";
import pages from './testimonypagedata';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

const TestimonyPage = () => {
  const [currentPage, setCurrentPage] = useState(0);

  const goToNextPage = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % pages.length); // Loop around to the first page
  };

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage - 1 + pages.length) % pages.length); // Loop around to the last page
  };

  // Don't render content until pages are loaded
  if (pages.length === 0) {
    return <div className="container">Loading...</div>;
  }

  return (
    <div className="container">
      <ArrowNavigation
        goToPreviousPage={goToPreviousPage}
        goToNextPage={goToNextPage}
        currentPage={currentPage}
        pages={pages}
      />
      <ContentDisplay content={pages[currentPage]} />
      <PageDots currentPage={currentPage} totalPages={pages.length} />
      <br />
    </div>
  );
};

export default TestimonyPage;